export default {
  high:    { label: 'High',    value: 2 },
  low:     { label: 'Low',     value: 0 },
  maximal: { label: 'Maximal', value: 3 },
  medium:  { label: 'Medium',  value: 1 }
};
